export default "__VITE_ASSET__sw_87fNn__"